import { render, staticRenderFns } from "./GeneratedTable.vue?vue&type=template&id=0cb0886a&scoped=true&"
import script from "./GeneratedTable.vue?vue&type=script&lang=js&"
export * from "./GeneratedTable.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedTable.vue?vue&type=style&index=0&id=0cb0886a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0886a",
  null
  
)

export default component.exports